import * as React from 'react';

import { isNumber } from '@impuls-coach/util-is';
import { routes } from 'defs';
import noop from 'helper/noop';

import ButtonBar from 'components/molecules/ButtonBar';
import { ButtonBarProps } from 'components/molecules/ButtonBar';
import Level from 'components/molecules/Level';
import { AnamnesisStepResolver } from 'components/organisms/Anamnesis';

type SelectActivityLevelState = {
	selectedLevel: number;
};

type SelectActivityLevelProps = {
	activityLevel: number;
	actionButtonsActive: ButtonBarProps;
	actionButtonsInactive: ButtonBarProps;
	isUpdatingAnamnesis: boolean;
	doSaveActivityLevel: Function;
	onNavigationClick: (targetUrl: { href: string }) => void;
	onStepCompleted: (resolver: AnamnesisStepResolver) => void;
};

export default class SelectActivityLevel extends React.Component<SelectActivityLevelProps, SelectActivityLevelState> {
	public static displayName = 'AnamnesisSelectActivityLevel';
	public static defaultProps = {
		actionButtonsActive: {},
		actionButtonsInactive: {},
		doSaveActivityLevel: noop,
		onNavigationClick: noop,
		onStepCompleted: noop,
		activityLevel: 0,
	};

	constructor(props: SelectActivityLevelProps) {
		super(props);

		this.state = {
			selectedLevel: props.activityLevel,
		};
	}

	public componentDidUpdate(prevProps: SelectActivityLevelProps) {
		if (prevProps.activityLevel && !isNumber(this.state.selectedLevel)) {
			this.setState({
				selectedLevel: prevProps.activityLevel,
			});
		}
	}

	public onLevelChange = (step: number) => {
		this.setState({
			selectedLevel: step,
		});
	};

	public onHandleButtonClicks = (type: string) => {
		const _this = this;
		const { onNavigationClick, onStepCompleted } = this.props;

		if (type === 'completed' && typeof onStepCompleted === 'function') {
			return onStepCompleted.apply(null, [
				{
					waitFor: 'savedActivityLevel',
					actionCreator: _this.props.doSaveActivityLevel,
					nextRoute: routes.anamnesis.verify,
					data: {
						intensity: _this.state.selectedLevel,
					},
				},
			]);
		}

		// Go back
		if (typeof onNavigationClick === 'function') {
			type = type === 'completed' ? 'next' : type;
			onNavigationClick.apply(this, [routes.anamnesis.selectDietaryHabits]);
		}
	};

	public render() {
		const { actionButtonsActive, actionButtonsInactive, activityLevel } = this.props;

		let actionButtons;

		if (Boolean(typeof this.state.selectedLevel === 'number' && this.state.selectedLevel >= 1)) {
			actionButtons = actionButtonsActive;
		} else {
			actionButtons = actionButtonsInactive;
		}

		return (
			<div>
				<Level preselected={activityLevel} onChange={this.onLevelChange} />
				<div className="o-anamnesis__button-bar">
					<ButtonBar
						{...actionButtons}
						loading={this.props.isUpdatingAnamnesis}
						handleButtonClicks={this.onHandleButtonClicks}
					/>
				</div>
			</div>
		);
	}
}
